import CloseAlerts from 'Components/alerts/assets/svg/CloseAlerts';
import AddLinkSvg from 'Components/common/assets/svgIcons/AddLinkSvg';
import GlobalButton from 'Components/common/components/GlobalButton';
import {
  primaryColor,
} from 'Utils/utilsStyle';
import { Drawer } from 'antd';
import React, { useEffect } from 'react';
import UploadDocumentSvg from 'Components/common/assets/svgIcons/UploadDocumentSvg';
import classNames from 'classnames';
import DuplicateFilePopup from 'Components/common/modal/DuplicateFilePopup';
import { selectFoldersPopupVisible, selectuploadingFileError } from 'Selector/DocumentHubSelector';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import UploadDocumentComponent from './UploadDocumentComponent';
import MultipleFileUploadComponent from './MultipleFileUploadComponent';

type Props = {
  inSmartDrawer: boolean;
  visible: boolean,
  state: string
  handleDrawerClose: () => void,
  handleStateChange: (a: string) => void,
  uploading: boolean
  uploadCancelled: boolean
  isNextUpload: boolean
};
const FooterDrawer = styled.div`
display: flex;
align-items: center;
justify-content: flex-end;
background: #FFF;
padding: 12px 14px;
`;

const DrawerUploadDocument = function DrawerUploadDocument(props: Props) {
  const {
    visible, handleDrawerClose, uploading,
    state, handleStateChange, uploadCancelled, isNextUpload, inSmartDrawer,
  } = props;
  const addLinkState = state === 'link';
  const disable = (uploading && !uploadCancelled) || (uploadCancelled && isNextUpload);
  const uploadingFileError = useSelector(selectuploadingFileError);
  const foldersPopupVisible = useSelector(selectFoldersPopupVisible);

  useEffect(() => {
    const node = document.querySelector('body');
    return visible ? node?.classList.add('body-drawer-toggle') : node?.classList.remove('body-drawer-toggle');
  }, [visible]);

  return (
    <Drawer
      rootClassName={classNames('drawer-alerts drawer-upload-document', { sapUploadDrawer: inSmartDrawer })}
      placement="right"
      open={visible}
      width={inSmartDrawer ? 530 : 600}
      maskClosable={!foldersPopupVisible}
      onClose={handleDrawerClose}
      extra={(
        <span
          onClick={handleDrawerClose}
          onKeyPress={handleDrawerClose}
          tabIndex={0}
          role="button"
          aria-label="close"
          className="close-alerts"
        >
          <CloseAlerts />
        </span>
      )}
    >
      <h1 className="drawer-heading">Upload Document</h1>
      <div className="upload-btn-div">
        <GlobalButton
          title="Add file"
          bgColor={!addLinkState ? primaryColor : '#fff'}
          textColor={!addLinkState ? '#fff' : '#7E7E7E'}
          outlineColor={!addLinkState ? primaryColor : '#DADADA'}
          RightSeparator
          IconRight={<UploadDocumentSvg color={!addLinkState ? '#fff' : '#7E7E7E'} />}
          PaddingSm="5px 10px"
          innerSpace="5px 10px"
          heightSm="30px"
          onButtonClick={() => handleStateChange('file')}
          buttonClassName="add-file-btn"
          disabled={disable}
        />
        <GlobalButton
          title="Add link"
          textColor={addLinkState ? '#fff' : '#7E7E7E'}
          bgColor={addLinkState ? primaryColor : '#fff'}
          IconRight={<AddLinkSvg color={addLinkState ? '#fff' : '#7E7E7E'} />}
          outlineColor={addLinkState ? primaryColor : '#DADADA'}
          RightSeparator
          leftSeparatorColor="#DADADA"
          LeftSpace="12px"
          PaddingSm="5px 10px"
          innerSpace="5px 10px"
          heightSm="30px"
          onButtonClick={() => handleStateChange('link')}
          buttonClassName="add-link-btn"
          disabled={disable}
        />
      </div>
      <UploadDocumentComponent
        inSmartDrawer={inSmartDrawer}
        addLinkState={state === 'link'}
        loader={disable}
      />
      {!uploadCancelled || isNextUpload
        ? (
          <MultipleFileUploadComponent
            uploading={uploading || isNextUpload}
            disableCancel={isNextUpload}
          />
        ) : null}
      {
        uploadingFileError
        && (
          <DuplicateFilePopup />
        )
      }
    </Drawer>
  );
};
export default DrawerUploadDocument;
